export default {
  daimlerPrimary: 'rgba(38, 92, 121, 1)', // Daimler-Teal-Primary 265c79
  daimlerSecondary: 'rgba(1, 122, 146, 1)', // Daimler-Teal-Secondary 017a92
  daimlerAccent: 'rgba(0, 183, 191, 1)', // Daimler-Teal-Accent 00b7bf
  daimlerAccentHover: 'rgba(0, 183, 191, 0.2)', // Daimler-Teal-Accent 00b9be
  daimlerAccentSelected: 'rgba(0, 183, 191, 0.4)', // Daimler-Teal-Accent 00b7bf
  black: 'rgba(7, 7, 15, 1)', // Full-Black 07070f
  blackPrimary: 'rgba(7, 7, 15, 0.87)', // 070715de
  blackSecondary: 'rgba(7, 7, 15, 0.7)', // 070715b3
  blackPrimaryShadow: 'rgba(7, 7, 15, 0.1)', // 07070f1a
  greyPrimary: 'rgba(7, 7, 15, 0.4)', // Dark-Grey 07071566
  grey: 'rgba(227, 229, 232, 1)', // Mid-Grey e3e5e8
  greySecondary: 'rgba(241, 242, 243, 1)', // Light-Grey-Secondary f1f2f3
  offWhite: 'rgba(248, 248, 249, 1)', // f8f8f9
  whitePrimary: 'rgba(255, 255, 255, 1)', // ffffff
  whiteSecondary: 'rgba(255, 255, 255, 0.87)', // ffffffde
  whitePressed: 'rgba(255, 255, 255, 0.7)', // ffffffb3
  whiteDisabled: 'rgba(255, 255, 255, 0.3)', // ffffff4c
  slatePrimary: 'rgba(79, 87, 100, 1)', // Dark-Slate-Primary 4f5764
  slateSecondary: 'rgba(104, 117, 133, 1)', // 687585
  slateLight: 'rgba(140, 150, 162, 1)', // Light-Slate-Disabled 8c96a2
  slateDisabled: 'rgba(140, 150, 162, 1)', // Light-Slate-Disabled 8c96a2
  bluePrimary: 'rgba(11, 46, 107, 1)', // Dark-Blue-Primary 0b2e6b
  blueSecondary: 'rgba(0, 81, 196, 1)', // Selected-Blue-Secondary 0051c4
  blueAccent: 'rgba(30, 122, 255, 1)', // Bright-Blue-Accent, Selected 1e7aff
  blueLight: 'rgba(232, 241, 255, 1)', // e8f1ff
  blueAvailable: 'rgba(193, 218, 255, 1)', // Available c1daff
  errorSecondary: 'rgba(148, 4, 10, 1)', // Dark-Alert-Pressed 94040a
  errorPrimary: 'rgba(180, 4, 12, 1)', // Red-Alert-Primary b4040c
  errorAccent: 'rgba(212, 4, 14, 1)', // Red-Alert-Accent d4040e
  warningAccent: 'rgba(239, 177, 21, 1)', // Warning-Yellow-Accent efb115
  warningPrimary: 'rgba(255, 198, 39, 1)', // Warning-Yellow-Primary ffc627
  confirmPrimary: 'rgba(57, 135, 18, 1)', // Confirm-Green-Primary 398712
  confirmAccent: 'rgba(71, 168, 23, 1)', // Confirm-Green-Accent 47a817
  confirmSecondary: 'rgba(48, 166, 33, 1)', // Confirm-Green-Secondary 30a621
  shadow: 'rgba(7, 7, 15, 0.3)',
  solidGrey: 'rgba(156, 156, 159, 1)',
  modalGrey: 'rgba(251,251,251,1)', // fbfbfb
  primaryPurple: 'rgba(108, 24, 186, 1.0)',
  lightPurple: 'rgba(108, 24, 186, 0.4)',
  // Banner Notification colors (from Figma MCP)
  bannerInfoBlue: 'rgba(50, 106, 247, 1)', // Information Blue #326AF7
  bannerInfoBlueLight: 'rgba(50, 106, 247, 0.3)', // Information Blue at 30% opacity (spinner)
  warningOrange: 'rgba(216, 67, 21, 1)', // Warning orange for errors #D84315
  // UI State colors
  blackHover: 'rgba(7, 7, 15, 0.9)', // Black hover state
  greyHover: 'rgba(250, 250, 250, 1)', // Table row hover #FAFAFA
  greyBorder: 'rgba(217, 217, 217, 1)', // Button border grey #D9D9D9
  greyDisabled: 'rgba(153, 153, 153, 1)', // Empty state text #999999
  whiteHover: 'rgba(255, 255, 255, 0.15)', // White overlay for hover states
}
